import { gql } from '@apollo/client'

import { MutationService, getMutationService } from '../../../../helpers/GraphqlHelpers'
import { UserFragment } from '../../../fragments'
import { LoginMutation } from '../../../generated/graphql'

export const login: MutationService = getMutationService({
  mutation: gql`
    mutation login($email: String!, $password: String!) {
      login(email: $email, password: $password) {
        ...UserFragment
      }
    }
    ${UserFragment}
  `,
  transformer: (response: LoginMutation) => {
    return response.login
  },
})
